import type {OrgCustomPropertiesDefinitionsPagePayload} from '@github-ui/custom-properties-types'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {DefinitionsList} from '../components/DefinitionsList'
import {PropertiesHeaderPageTabs} from '../components/PropertiesHeaderPageTabs'

export function OrgCustomPropertiesListPage() {
  const {definitions, permissions, business} = useRoutePayload<OrgCustomPropertiesDefinitionsPagePayload>()

  return (
    <>
      <PropertiesHeaderPageTabs permissions={permissions} definitions={definitions} />
      <DefinitionsList totalCount={definitions.length} definitions={definitions} business={business} />
    </>
  )
}

try{ OrgCustomPropertiesListPage.displayName ||= 'OrgCustomPropertiesListPage' } catch {}